

import React from 'react';

import Commonshape from './Commonshape';
import Popultypebulbs from './Popultypebulbs';
import Typerotary from './Typerotary';
import Bulbcoverprodtabl from './Bulbcoverprodtabl';


const Commonshapesbul = () => {
    return (
        <div>
           <Commonshape />
            <Popultypebulbs />
            <Typerotary />
            <Bulbcoverprodtabl />

        </div>
    );
};

export default Commonshapesbul;
